import { Observable, BehaviorSubject } from "rxjs";

export interface IPage<T>
{
    total: number;
    pageNumber: number;
    pageSize: number;
    rows: T[];
}

export interface PageResult<T>
{
    totalCount: number,
    items: T[]
}

export interface IPageChangeEvent
{
    length: number,
    pageIndex: number,
    pageSize: number,
    previousPageIndex: number
}

export type PageDataAccessor<T> = (pageNumber: number, pageSize: number) => Observable<IPage<T>>;

export class PaginatorHandler<T>
{
  private page: IPage<T> = {
    pageNumber: 0,
    pageSize: 10,
    total: 0,
    rows: [],
  };

  pageUpdate$ = new BehaviorSubject<IPage<T>>(this.page);

  get hasRows(): boolean
  {
    return this.page.rows.length > 0;
  }

  get rows(): T[]
  {
    return this.page.rows;
  }

  get pageSize(): number
  {
    return this.page.pageSize;
  }

  get pageNumber(): number
  {
    return this.page.pageNumber;
  }

  set setPageNumber(page: any)
  {
    this.page.pageNumber = page;
  }

  get total(): number
  {
    return this.page.total;
  }

  /**
     * @param getPageData A callback to get data (from an api e.g.)
     *
     */
  constructor(private getPageData: PageDataAccessor<T>) { }

  getPage(pageNumber: number = 0, pageSize: number = 10): Observable<IPage<T>>
  {
    this.page.pageSize = pageSize;
    this.getPageData(pageNumber, this.page.pageSize).subscribe(
      page => this.pageUpdate$.next(this.page = page),
      error => this.pageUpdate$.error(error));

    return this.pageUpdate$;
  }

  /**
     * Subscribe this method on Material Pagination (page) event triggering
     *
     * @param e
     */
  onPageChange(e: IPageChangeEvent): void
  {
    this.page.pageNumber = e.pageSize === this.page.pageSize ? e.pageIndex : 0;
    this.page.pageSize = e.pageSize;

    this.getPageData(this.page.pageNumber, this.page.pageSize).subscribe(
      page => this.pageUpdate$.next(this.page = page),
      error => this.pageUpdate$.error(error));
  }
}
